export default __webpack_public_path__ + "assets/ef3fe9e8faf8dc343b960afeede54f47.png";